export default class StorepointInitialDelete {

    constructor() {

        this.storeLocatorWrapper = document.querySelector(".c-store-locator");

        if (this.storeLocatorWrapper) {
            this.init();

        }


    }

    init() {
        this.storepointLocation = document.querySelectorAll(".storepoint-location");

        if (this.storepointLocation.length > 0) {
            this.storepointLocation.forEach((element) => {
                element.remove();
            });

            return;

        } else {
            setTimeout(() => {
                this.init();
            }, 300);
        }
    }
}
